import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IonContent, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { CashierBase } from '../../cashier-base/cashier-base';

@Component({
  selector: 'app-deposit-pay-with-cash',
  templateUrl: './deposit-pay-with-cash.component.html',
  styleUrls: ['./deposit-pay-with-cash.component.scss'],
})
export class DepositPayWithCashComponent extends CashierBase implements OnInit {

    @ViewChild(IonContent, { static: false }) content: IonContent;
    @Input() public navigateBackPage: any;
    @Input() bonusCode: any
     
    public iframe_url;
    public showError = false;
    public isMobile;
    public loading: boolean = true;
    public error = null;

    constructor(
      public platform:Platform,
      private sanitizer: DomSanitizer,
      private navigator: Navigator,
      protected userSessionProvider: UserSessionService,
      protected cashierProvider: CashierService,
      protected events: EventsService,
      public cashierContentService: CashierContentService
    ){
        super();
    }

    ngOnInit() {
        this.cashierProvider.getPaynearmeUrl(this.bonusCode).subscribe(
            response => {
                if (response.payload) {
                    this.iframe_url = this.sanitizer.bypassSecurityTrustResourceUrl(response.payload);
                } else {
                    this.showError = true;
                }
            }, error => {
                this.showError = true;
                this.content.scrollToTop(10);
                this.error = this.handleError(error);
            }
        )
    }

    ionViewDidLoad() {
        this.isMobile = (this.platform.is('cordova')) ? true : false;
    }

    public loadiFrame() {
        this.loading = true;
        setTimeout(() => {
                this.loading = false;
        }, 1000);
    }

    closeDialog() {
        this.navigator.toLobby();
    }

    onBack = () => {
        this.cashierContentService.onBackHandler(this.navigateBackPage);
    }
}
